import React from "react";
import Loader from "../../../Loader";

const SkeletonCard = () => (
  <div className="rounded-2xl border border-white/10 bg-bgSecondary dark:glass-effect p-5 space-y-3 animate-pulse">
    <div className="flex items-start gap-3">
      <div className="h-4 w-6 bg-white/10 rounded" />
      <div className="flex-1 space-y-2">
        <div className="h-3 bg-white/10 rounded w-4/5" />
        <div className="h-3 bg-white/10 rounded w-3/5" />
      </div>
    </div>
    <div className="space-y-2 pl-6">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="h-8 bg-white/5 rounded-xl" />
      ))}
    </div>
  </div>
);

const GeneratingLoader = () => (
  <div className="space-y-4">
    <div className="flex flex-col items-center gap-2 py-4">
      <div className="h-16 w-16">
        <Loader />
      </div>
      <p className="text-sm font-medium dark:text-gray-300 text-textSecondary">
        Generating your questions...
      </p>
      <p className="text-xs dark:text-gray-500 text-textSecondary">
        This may take a moment for larger sets.
      </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {[1, 2, 3, 4].map((i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  </div>
);

export default GeneratingLoader;
